export default "__VITE_PUBLIC_ASSET__b3badfe3__"